module.exports = __webpack_public_path__ + "static/media/RomanSerif-01.d03353b1.svg";